import builder from '../builder';
import CameraSettingsRotate1 from '../../streamline-icons/light/camera-settings-rotate-1.svg';

export default builder('IconCameraSettingsRotate1Light', CameraSettingsRotate1);
